/**
 * Gewässer-Abschnitte aus ArTrack (Alex 2026-10-23: „der zeigt mir alle
 * Flüsse an, aber ich will angeben, welche Flüsse von wo bis wo").
 *
 * Alex legt im ArTrack-Editor Abschnitte an (Panel „OSM-Routen", Art
 * Gewässer) und gibt sie frei. `GET /tracks/{id}/routes?art=gewaesser`
 * liefert nur freigegebene; die Punkte kommen wie bei Wegen über
 * gps-points in voller OSM-Auflösung (ArTrack 3805e08, Post #5628).
 *
 * Gibt es noch keinen Abschnitt oder scheitert ArTrack, zeigt die Ebene
 * wie bisher alle OSM-Bäche aus der Datei (`rueckfallUrl`).
 */
type Linie = { art: string; name?: string; punkte: [number, number][] }

interface Route { id: number; name?: string; metadata_json?: { osm_art?: string } | null }
interface Punkt { latitude: number; longitude: number }

export function gewaesserLoader(opts: {
  api: () => { artrackUrl: string; apiKey: string; trackId: number }
  rueckfallUrl: string
}): () => Promise<Linie[]> {
  const rueckfall = async (): Promise<Linie[]> => {
    const r = await fetch(opts.rueckfallUrl)
    if (!r.ok) throw new Error(`HTTP ${r.status}`)
    return ((await r.json()) as { linien?: Linie[] }).linien ?? []
  }
  return async () => {
    const { artrackUrl, apiKey, trackId } = opts.api()
    const headers = { 'X-API-KEY': apiKey }
    try {
      const r = await fetch(`${artrackUrl}/tracks/${trackId}/routes?art=gewaesser`, { headers })
      if (!r.ok) throw new Error(`HTTP ${r.status}`)
      const routen = (await r.json()) as Route[]
      if (!Array.isArray(routen) || routen.length === 0) return rueckfall()
      const linien = await Promise.all(routen.map(async (rt): Promise<Linie> => {
        const p = await fetch(`${artrackUrl}/tracks/${trackId}/gps-points?route_id=${rt.id}&limit=10000`, { headers })
        if (!p.ok) throw new Error(`HTTP ${p.status}`)
        const punkte = ((await p.json()) as Punkt[]).map((q): [number, number] => [q.longitude, q.latitude])
        return { art: rt.metadata_json?.osm_art ?? 'stream', name: rt.name, punkte }
      }))
      return linien.filter((l) => l.punkte.length >= 2)
    } catch (e) {
      console.warn('[Gewässer] ArTrack-Abschnitte nicht ladbar, zeige alle OSM-Bäche:', e)
      return rueckfall()
    }
  }
}
